import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();
  const [fecha, setFecha] = useState(new Date());

  useEffect(() => {
    setFecha(new Date());
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <footer
      id="idFooter"
      className="bg-primary text-white pt-10 pb-6 px-6 md:px-[10vw]"
    >
      {/* Logo + mini descripción */}
      <section className="flex flex-col items-center gap-3 mb-8">
        <Button
          aria-label="Scroll Home"
          disableRipple
          style={{ backgroundColor: "transparent" }}
          onClick={() => scrollToSection("idHome")}
        >
          <img
            loading="lazy"
            width={60}
            height={60}
            src="/assets/footer/isotipowhite.svg"
            alt="Isotipo Box Collider"
          />
        </Button>
        <p className="max-w-xl text-center text-sm md:text-base font-montserratregular text-gray-200">
          {t("footer0")}
        </p>
      </section>

      {/* Bloque principal */}
      <section className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10 mb-6">
        {/* Síguenos */}
        <div className="flex flex-col items-center md:items-start gap-3">
          <h2 className="text-lg font-montserratregular">{t("footer1") || "Síguenos"}</h2>
          <div className="flex justify-center md:justify-start gap-4">
            <a
              href="https://www.facebook.com/BoxColliderDevs"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <img
                width={24}
                height={24}
                src="/assets/footer/facebook.svg"
                alt="Facebook"
              />
            </a>
            <a
              href="https://www.instagram.com/BoxColliderDevs/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <img
                width={24}
                height={24}
                src="/assets/footer/instagram.svg"
                alt="Instagram"
              />
            </a>
            <a
              href="https://mx.linkedin.com/company/boxcollider"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <img
                width={24}
                height={24}
                src="/assets/footer/linkedin.svg"
                alt="LinkedIn"
              />
            </a>
          </div>
        </div>

        {/* Navegación rápida */}
        <div className="flex flex-col items-center md:items-start gap-2">
          <h2 className="text-lg font-montserratregular">
            {t("footer2") || "Secciones"}
          </h2>
          <button
            type="button"
            className="text-sm text-gray-200 hover:text-white transition"
            onClick={() => scrollToSection("idHero")}
          >
            {t("footer21")}
          </button>
          <button
            type="button"
            className="text-sm text-gray-200 hover:text-white transition"
            onClick={() => scrollToSection("idServicios")}
          >
            {t("footer22")}
          </button>
          <button
            type="button"
            className="text-sm text-gray-200 hover:text-white transition"
            onClick={() => scrollToSection("idPortafolio")}
          >
            {t("footer23")}
          </button>
          <button
            type="button"
            className="text-sm text-gray-200 hover:text-white transition"
            onClick={() => scrollToSection("idColaboradores")}
          >
            {t("footer24")}
          </button>
        </div>

        {/* Ubicación */}
        <div className="flex flex-col items-center md:items-start gap-2">
          <h2 className="text-lg font-montserratregular">
            {t("footer3") || "Ubicación"}
          </h2>
          <p className="text-sm md:text-base text-center md:text-left font-montserratregular">
            Morelia, Michoacán, México
          </p>
        </div>

        {/* Contáctanos */}
        <div className="flex flex-col items-center md:items-start gap-3">
          <h2 className="text-lg font-montserratregular">{t("footer4")}</h2>
          <div className="flex gap-4">
            <a
              href="mailto:contacto@boxcollider.com.mx"
              aria-label="Mail To"
            >
              <img
                width={24}
                height={24}
                src="/assets/footer/email.svg"
                alt="Mail"
              />
            </a>
            <a
              href="https://api.whatsapp.com/send?phone=5214431819520&amp;text=Hola%2C%20me%20gustar%C3%ADa%20obtener%20una%20cotizaci%C3%B3n."
              target="_blank"
              rel="noreferrer"
              aria-label="Whatsapp"
            >
              <img
                width={24}
                height={24}
                src="/assets/footer/whatsapp.svg"
                alt="Whatsapp"
              />
            </a>
          </div>
        </div>
      </section>

      {/* Línea inferior */}
      <section className="border-t border-white/10 pt-4 flex flex-col items-center text-xs md:text-sm font-montserratregular">
        <p className="text-center">
          {t("footer5")}
          {fecha.getFullYear()}
        </p>
      </section>
    </footer>
  );
};